<template>
  <section :class="` bg-[#2A3A48]  border-t border-gray-700 bottom-0 `">
    <div class="relative footer-animation overflow-hidden">
      <div class="flex justify-center main-footer relative">
        <div class="main-wrapper relative z-[2] py-6">
          <div>
            <div class="mb-6 md:mb-0">
              <div class="w-full flex justify-center">
                <a href="/" class="flex flex-col gap-1">
                  <img
                    :src="Logo"
                    class="mr-3 aspect-video h-auto lg:h-40 w-60"
                    alt="NGHIENGACHA Logo"
                  />
                </a>
              </div>
              <div class="w-full flex justify-center">
                <span
                  class="text-center text-2xl font-semibold text-white dark:text-white"
                >
                  Chuyên cấp các tài khoản game gacha
                </span>
              </div>
            </div>
            <div class="w-full flex justify-center">
              <div class="border-b w-full md:w-[900px] h-2"></div>
            </div>

            <ul
              class="flex flex-wrap justify-center gap-4 sm:gap-7 items-center mx-auto max-w-7xl px-3 py-4"
            >
              <FooterLink :href="route('policy')" text="Điều khoản dịch vụ" />
              <FooterLink :href="route('policy')" text="Chính Sách Bảo Hành" />

              <FooterLink :href="route('sigin_client')" text="Đăng ký" />
              <FooterLink :href="route('login')" text="Đăng nhập" />
            </ul>
            <ul
              class="flex flex-wrap justify-center gap-4 sm:gap-7 items-center mx-auto max-w-7xl px-3 py-4"
            >
              <FooterLink href="#" text="Hotline: 0369890451" />
              <FooterLink href="#" text="Email: kazuha23052002@gmail.com" />
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style>
.footer-animation .main-footer {
  bottom: 0;
  height: 100%;
  width: 100%;
  background: url('../../images/wave.png') repeat-x;
  background-size: 250rem 30rem;
  animation: animate 15s linear infinite;
}

@keyframes animate {
  0% {
    background-position-x: 0;
    background-position-x: -180rem;
  }
}

.footer-animation .main-footer:nth-child(1) {
  opacity: 0.9;
}

.footer-animation .main-footer:nth-child(2) {
  opacity: 0.5;
  animation-delay: 0.2s;
  animation-direction: reverse;
}

.footer-animation .main-footer:nth-child(3) {
  opacity: 0.7;
  animation-delay: 5s;
}
</style>

<script setup>
import route from 'ziggy-js'
import FooterLink from './FooterLink.vue'
import Logo from '../../images/logo.png'
</script>
